<template>
  <div class="friends row justify-content-center">
    <b-modal ref="removeConfirmation" id="removeConfirmation" title="Ta bort grupp" @ok="removeAction" @cancel="removeCancel" close-title="Nej" ok-title="Ja">
        <span>Vill du ta bort din grupp?</span>
    </b-modal>
    <div class="col-md-8">
        <div class="row">
            <div class="col-sm-7">
                <h2>Grupper</h2>
            </div>
            <div class="col-sm">
                <div class="input-group">
                    <input type="text" v-model="name" class="form-control" placeholder="Namn" required autofocus>
                    <span class="input-group-btn">
                        <button @click="create()" type="button" class="btn btn-md btn-primary">Lägg till</button>
                    </span>
                </div>
            </div>
        </div>
        <table class="table table-bordered table-striped group-table">
            <thead>
                <tr>
                    <th>Namn</th>
                    <th>Hantera</th>
                    <th>Yta</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(group, index) in groups">
                    <router-link tag="td" active-class="active" :to="'/group/' + group.id" v-on:click.native="select({group, index})" exact>
                        <a>{{ group.name }}</a>
                    </router-link>
                    <td>
                        <button class="btn btn-primary" v-on:click="selectForRemoval({group, index})">Ta bort</button>
                    </td>
                    <td>
                        <b-form-select text-field="name" value-field="id" :value="group.workarea" :options="workareas" @input="value => updateWorkarea(value, group)" class="mb-3">
                        </b-form-select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'groups',
    computed: {
        groups () {
            return this.$store.state.group.groups
        },
        workareas () {
            return this.$store.state.workarea.workareas
        }
    },
    data () {
        return {
            name: '',
            group: null
        }
    },
    mounted () {
        this.name = ''
        this.refresh()
    },
    methods: {
        ...mapActions({
            refresh: 'group_list',
            remove: 'group_delete',
            insert: 'group_post',
            select: 'group_select',
            update: 'group_put'
        }),
        create: function () {
            if (this.name === '' || this.name === undefined) {
                return
            }

            this.insert(this.name)
        },
        selectForRemoval: function ({group, index}) {
            this.group = {group, index}
            this.$refs.removeConfirmation.show()
        },
        removeAction: function () {
            this.remove(this.group)
        },
        removeCancel: function () {
            this.group = null
        },
        updateWorkarea: function (value, group) {
            if (value !== group.workarea) {
                console.log('UPDATE: ', value, group.workarea, group.name)
                this.update({group, workarea: value})
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Groups.vue